import KetExam from './component';

import { ketMockExamRoutes, ketScoreRoutes } from './routes';

export { ketMockExamRoutes, ketScoreRoutes };

export default KetExam;



// WEBPACK FOOTER //
// ./containers/Group/KetExam/index.js